import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const CSS_Errors = () => {
  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">⚠️ CSS Errors</h1>

      <p className="tutorial-intro">
        Writing CSS is straightforward, but beginners often make mistakes that
        prevent styles from being applied correctly. Let’s explore the most
        common CSS errors and how to fix them.
      </p>

      {/* Missing Semicolon */}
      <div className="tutorial-section">
        <h2 className="section-title">❌ Missing Semicolon</h2>
        <p>
          Each CSS declaration must end with a semicolon. Forgetting it can
          break your styles.
        </p>
        <p className="section-subtitle">Wrong ❌</p>
        <CodeCopyBlock
          code={`p {
  color: red
  font-size: 16px;
}`}
        />
        <p className="section-subtitle">Correct ✅</p>
        <CodeCopyBlock
          code={`p {
  color: red;
  font-size: 16px;
}`}
        />
      </div>

      {/* Wrong Selector */}
      <div className="tutorial-section">
        <h2 className="section-title">❌ Wrong Selector</h2>
        <p>
          If your selector doesn’t match the HTML element, the style won’t be
          applied.
        </p>
        <p className="section-subtitle">Example:</p>
        <CodeCopyBlock
          code={`<!-- HTML -->
<p>Hello World</p>

/* CSS */
h1 {
  color: blue;
}`}
        />
        <p>
          Here, the selector <code>h1</code> does not match{" "}
          <code>&lt;p&gt;</code>, so nothing changes.
        </p>
      </div>

      {/* Misspelled Property */}
      <div className="tutorial-section">
        <h2 className="section-title">❌ Misspelled Property or Value</h2>
        <p>
          Spelling matters in CSS. Browsers ignore invalid properties or values.
        </p>
        <CodeCopyBlock
          code={`p {
  colr: red;   /* Wrong */
  font-sze: 16px; /* Wrong */
}`}
        />
        <p>✅ Correct:</p>
        <CodeCopyBlock
          code={`p {
  color: red;
  font-size: 16px;
}`}
        />
      </div>

      {/* Debugging CSS */}
      <div className="tutorial-section">
        <h2 className="section-title">🛠️ Debugging CSS</h2>
        <ul className="tutorial-list">
          <li>
            Use browser <strong>Developer Tools</strong> (F12) to inspect
            elements and check applied CSS.
          </li>
          <li>Check the browser console for warnings or invalid rules.</li>
          <li>
            Validate your CSS with{" "}
            <a
              href="https://jigsaw.w3.org/css-validator/"
              target="_blank"
              rel="noopener noreferrer"
              className="learn-more"
            >
              W3C CSS Validator
            </a>
            .
          </li>
        </ul>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          Now that you know how to avoid common errors, continue with{" "}
          <a href="/css/colors" className="learn-more">
            CSS Colors
          </a>{" "}
          to start styling your elements with beautiful color schemes.
        </p>
      </div>
    </div>
  );
};

export default CSS_Errors;
